import { Link } from "@inertiajs/react"

const Footer = () => (
  <footer className="py-12 text-sm text-gray-600">
    --
    <br />A project by Lakpa SLU.
    <br />
    <Link
      href="/about"
      className="underline hover:text-white hover:no-underline"
    >
      About
    </Link>
    <span className="mx-2">&bull;</span>
    <Link
      href="/privacy"
      className="underline hover:text-white hover:no-underline"
    >
      Privacy Policy
    </Link>
  </footer>
)

export default Footer
